'use strict';

var $ = window.jQuery;
var Cycle = require('../lib/third-party/jquery.cycle.js');

function init() {
		var slideshow = $('.masthead .cycle-slideshow');
		if (slideshow.length === 0) {
			return;
		}
		
		slideshow.cycle({
			speed : 1000,
			autoHeight : -1,
			delay : 0,
			timeout : 3000,
			slides : $('.masthead__slide', slideshow)
		})
		.one('cycle-initialized');
}

module.exports = {
	init: init
};
